import { dropdownPropsType } from "@/components/controls/Dropdown/Dropdown";
import { TFunction } from "i18next";
import { fromPairs, map } from "lodash";

export const periodsDropdownProps = (
  t: TFunction<"translation", undefined>
): dropdownPropsType => ({
  label: t("conversionRates.dealsClosedAt"),
  options: fromPairs(
    map(["ytd", "last12m", "last24m", "allTimes"], (timeframe) => [
      timeframe,
      t(`timeframes.${timeframe}`)
    ])
  ),
  defaultValue: "allTimes"
});
